import React from "react";
import ReactDOM from "react-dom/client";

import "@shared/theme/fonts.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AppBootstrap } from "@/config/AppBootstrap";
// import i18n so it is bundled and loaded immediately when application loads
import "@/translations";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppBootstrap />
    </QueryClientProvider>
  </React.StrictMode>
);
